module.exports = __webpack_public_path__ + "img/ionic.12013e56.png";